import {
    Button,
    styled,
    fromTheme,
    Pressable,
    View,
    Text,
    webOnlyStyles,
    nativeOnlyStyles,
    h3,
    h1,
    Card,
    ScrollView
} from 'lib_ui-primitives';

let _FullScreenBody = nativeOnlyStyles(Card.Body)`
    flex-grow: 1;
    width: ${fromTheme('notifications', 'maxWidthOnMobile')};
`;
_FullScreenBody = webOnlyStyles(_FullScreenBody)`
    width: ${({ theme }) => `${theme.mobile ? theme.width : theme.width * 0.8}px`};
`;
export const FullScreenBody = _FullScreenBody;
export const ClearAll = styled(Button)`
    align-self: center;
    width: 100%;
`;

let _TopButtonBar = styled(View)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    padding: ${fromTheme('notifications', 'header', 'buttonBar', 'padding')};
    border-bottom-width: 1px;
    border-bottom-color: ${fromTheme('menu', 'divider', 'color')};
`;

_TopButtonBar = nativeOnlyStyles(_TopButtonBar)`
    width: ${fromTheme('notifications', 'maxWidthOnMobile')};
`;

export const TopButtonBar = webOnlyStyles(_TopButtonBar)`
    width: 100%;
    border-bottom: 1px solid ${fromTheme('menu', 'divider', 'color')};
    box-sizing: border-box;
`;

export const HeaderTitleContainer = styled(View)`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${fromTheme('notifications', 'gap')};
`;

export const NoNotifications = styled(h3)`
    margin: ${fromTheme('notifications', 'emptyState', 'margin')};
    font-size: ${fromTheme('notifications', 'emptyState', 'fontSize')};
`;

export const Title = styled(h1)`
    ${fromTheme('notifications', 'header', 'title', 'font')}
    color: ${fromTheme('notifications', 'header', 'title', 'color')};
`;





export const InnerRow = styled(View).attrs({ name: 'inner-row' })`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 100%;
    gap: ${fromTheme('notifications', 'gap')};
    box-sizing: border-box;
`;

let _Row = styled(Pressable).attrs({ name: 'row' })`
    display: flex;
    flex-direction: column;
    padding: ${fromTheme('notifications', 'row', 'padding')};
    border-bottom-width: 1px;
    border-bottom-color: ${fromTheme('menu', 'divider', 'color')};
    position: relative;
    background-color: transparent;
`;

_Row = nativeOnlyStyles(_Row)`
    width: ${fromTheme('notifications', 'maxWidthOnMobile')};
`;

export const Row = webOnlyStyles(_Row)`
    border-bottom: 1px solid ${fromTheme('menu', 'divider', 'color')};
    transition: ${fromTheme('notifications', 'row', 'transition')};
    box-sizing: border-box;
    overflow: hidden;
    min-height: 70px;

    &:hover {
        background-color: ${fromTheme('menu', 'menuItem', 'hoverBackgroundColor')};
        .remove-button {
            opacity: 1;
        }
    }
    &:last-child {
        border-bottom: none;
    }
`;

let _MessageText = styled(Text)`
    min-width: 0;
    padding: ${fromTheme('textPadding')};
    overflow: hidden;
`;
export const MessageText = webOnlyStyles(_MessageText)`
    white-space: normal;
    word-break: break-word;
    ${fromTheme('notifications', 'row', 'message')};
    line-height: ${fromTheme('notifications', 'lineHeight')};
    color: ${fromTheme('defaultFontColor')};
`;

export const TextContainer = styled(View)`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    padding: ${fromTheme('notifications', 'row', 'message', 'container', 'padding')};
`;
TextContainer.displayName = 'NotificationTextContainer';

// Start with native version that passes iconColor to the icon
let _RemoveButton = styled(Button).attrs(({ theme }) => ({ 
    className: 'remove-button',
    iconColor: theme.notifications?.row?.removeButton?.color
}))`
    margin: 0;
    padding: 0;
    height: ${fromTheme('notifications', 'row', 'iconSize')};
    width: ${fromTheme('notifications', 'row', 'iconSize')};
    flex-shrink: 0;
    opacity: ${({ theme }) => theme.mobile ? 1 : 0};
    background-color: transparent !important;
    margin-top: 0px;
`;

// Apply native-only styles (no additional styles needed for native)
_RemoveButton = nativeOnlyStyles(_RemoveButton)``;

// Layer web-specific styles on top
_RemoveButton = webOnlyStyles(_RemoveButton)`
    color: ${fromTheme('notifications', 'row', 'removeButton', 'color')} !important;
    transition: ${fromTheme('notifications', 'row', 'removeButton', 'transition')};
    
    &:hover, &:active {
        cursor: pointer;
        margin: 0 !important;
        padding: 0 !important;
        background: transparent;
        border-width: 0;
        box-shadow: none;
    }
    svg {
        width: ${fromTheme('notifications', 'row', 'iconSize')} !important;
        height: ${fromTheme('notifications', 'row', 'iconSize')} !important;
    }
`;

export const RemoveButton = _RemoveButton;

export const UnreadIndicatorContainer = styled(View)`
    width: ${fromTheme('notifications', 'unreadIndicator', 'containerWidth')};
    height: ${fromTheme('notifications', 'lineHeight')};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const TimeText = styled(Text)`
    ${fromTheme('notifications', 'timeAgo', 'font')};
    color: ${fromTheme('notifications', 'timeAgo', 'color')};
    margin-top: ${fromTheme('notifications', 'timeAgo', 'marginTop')};
`;

let _StyledList = styled(ScrollView).attrs({ name: 'notifications-list' })`
    display: flex;
    flex-direction: column;
    max-height: ${fromTheme('notifications', 'maxHeight')};
    min-width: ${fromTheme('notifications', 'minWidth')};
`;

_StyledList = nativeOnlyStyles(_StyledList)`
    width: ${fromTheme('notifications', 'maxWidthOnMobile')};
`;

export const StyledList = webOnlyStyles(_StyledList)`
    overflow-y: auto;
    box-sizing: border-box;
    max-width: ${fromTheme('notifications', 'maxWidth')};
`;
